import { render, staticRenderFns } from "./settingMixin.vue?vue&type=template&id=6045abad&scoped=true&"
import script from "./settingMixin.vue?vue&type=script&lang=js&"
export * from "./settingMixin.vue?vue&type=script&lang=js&"
import style0 from "./settingMixin.vue?vue&type=style&index=0&id=6045abad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6045abad",
  null
  
)

export default component.exports